// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'table-bolt-solid';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M8.324 12.908H2.021c-.869 0-1.521-.65-1.521-1.515V2.015C.5 1.149 1.152.5 2.021.5h11.302c.87 0 1.521.65 1.521 1.515v3.39' />
    <path
      fill='currentColor'
      d='M.5 4.612h14.344V2.015c0-.866-.652-1.515-1.52-1.515H2.02C1.152.5.5 1.15.5 2.015z'
    />
    <path d='M5.861 4.612v8.223m4.564-8.223v4.112m-9.925 0h9.925' />
    <path
      fill='currentColor'
      d='m15.28 7.281-4.275 5.194c-.073.072-.073.216-.073.288.073.073.145.145.218.145h1.883v4.472l4.275-5.194c.072-.072.072-.216.072-.288-.072-.072-.145-.145-.217-.145h-1.884z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
